import type { Board } from "./boardDeckStore";

/** Board tabs, skill boundaries and their agent rails share theme tokens. */
export const BOARD_ACCENT_BY_KIND: Readonly<Record<Board["kind"], string>> = {
  goals: "--ncl-section-harmony",
  preview: "--ncl-section-canvases",
  files: "--ncl-section-files",
  file: "--ncl-section-files",
  terminal: "--ncl-section-rooms",
  agents: "--ncl-section-ideas",
  usage: "--ncl-section-kpi",
  commerce: "--ncl-section-kpi",
  "world-commerce": "--ncl-section-kpi",
  "world-members": "--ncl-section-kpi",
  models: "--ncl-section-kpi",
  crm: "--ncl-section-kpi",
  music: "--music-provider-accent",
  boomgik: "--ncl-section-canvases",
  games: "--ncl-section-harmony",
  calendar: "--ncl-section-notify",
  settings: "--ncl-section-notify",
  inbox: "--ncl-section-messages",
  kanban: "--ncl-section-harmony",
  member: "--ncl-section-canvases",
  designer: "--ncl-section-canvases",
  media: "--ncl-section-canvases",
  websites: "--ncl-section-canvases",
  "sub-session": "--cleo-identity",
  workrooms: "--ncl-section-harmony",
  // GT5: a person's gates wear the answers hue the Inbox HITL rail already wears.
  "delegation-gates": "--ncl-section-answers",
  "platform-admin": "--ncl-section-answers",
  "mobile-app": "--ncl-section-canvases",
  components: "--ncl-section-canvases",
};

export function workroomAccentVariable(workroomKey: string): string {
  if (workroomKey === "commercial-operations") return BOARD_ACCENT_BY_KIND.commerce;
  return Object.hasOwn(BOARD_ACCENT_BY_KIND, workroomKey)
    ? BOARD_ACCENT_BY_KIND[workroomKey as Board["kind"]]
    : "--cleo-identity";
}
